import styled from 'styled-components';

export const NetWorthContent = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 48px;
  color: #444;

  > * + * {
    margin-top: 48px;
  }

  @media (min-width: 1200px) {
    flex-direction: row;
    align-items: flex-start;

    > * {
      flex: 1;
      margin: 0 24px;
    }

    > *:first-child {
      margin-left: 0;
      max-width: 480px;
    }

    > *:last-child {
      margin-right: 0;
    }
  }
`;
